<template>
  <div>
    <b-btn
      v-b-tooltip.hover
      variant="none"
      title="Histórico"
      class="btn btn-sm btn-none px-50 py-0"
      @click="show()"
    >
      <font-awesome-icon
        icon="fa-solid fa-list"
        class="text-primary"
      />
    </b-btn>

    <b-modal
      ref="modalHistorico"
      button-size="sm"
      no-close-on-backdrop
      no-stacking
      ok-only
      ok-title="Ok"
      size="xl"
      centered
      dialog-class="modal-historico-envio"
      cancel-title=""
      :cancel-disabled="true"
      cancel-variant="false"
    >
      <div slot="modal-title">
        <h5>Histórico - {{ tituloRotina }}</h5>
        <fieldset class="font-weight-bold text-muted">
          Alterações de configuração e envios realizados
        </fieldset>
      </div>

      <b-tabs>
        <!-- Aba Alteração -->
        <b-tab title="Alteração">
          <div v-if="carregandoAlteracoes" class="text-center py-3">
            <b-spinner small />
            Carregando...
          </div>
          <b-table
            v-else
            :items="logs"
            :fields="camposAlteracao"
            responsive
            small
            show-empty
            empty-text="Nenhuma alteração registrada"
          >
            <template #cell(data)="{ item }">
              {{ formatarData(item.data) }}
            </template>
            <template #cell(tipoAcao)="{ item }">
              <b-badge :variant="variantAcao(item.tipoAcao)">
                {{ labelAcao(item.tipoAcao) }}
              </b-badge>
            </template>
            <template #cell(de)="{ item }">
              <span v-if="item.tipoAcao === 0">{{ item.valorAnterior }}</span>
              <span v-else-if="item.tipoAcao === 2">
                {{ item.empresaCadastroFederal || `ID: ${item.empresaId}` }}
              </span>
            </template>
            <template #cell(para)="{ item }">
              <span v-if="item.tipoAcao === 0">{{ item.valorNovo }}</span>
              <span v-else-if="item.tipoAcao === 1">
                {{ item.empresaCadastroFederal || `ID: ${item.empresaId}` }}
              </span>
            </template>
          </b-table>
        </b-tab>

        <!-- Aba Histórico de envio -->
        <b-tab title="Histórico de envio">
          <div v-if="carregandoEnvios" class="text-center py-3">
            <b-spinner small />
            Carregando...
          </div>
          <b-table
            v-else
            :items="historicosEnvio"
            :fields="camposEnvio"
            responsive
            small
            show-empty
            empty-text="Nenhum envio registrado"
          >
            <template #cell(data)="{ item }">
              {{ formatarData(item.data) }}
            </template>
            <template #cell(empresaRazaoSocial)="{ item }">
              <span
                v-if="item.empresaRazaoSocial"
                v-b-tooltip.hover
                :title="item.empresaRazaoSocial"
                style="cursor: default;"
              >
                {{ item.empresaRazaoSocial.substring(0, 20) }}{{ item.empresaRazaoSocial.length > 20 ? '…' : '' }}
              </span>
            </template>
            <template #cell(status)="{ item }">
              <b-badge :variant="variantStatus(item.status)">
                {{ labelStatus(item.status) }}
              </b-badge>
            </template>
            <template #cell(erroMensagem)="{ item }">
              <span
                v-if="item.erroMensagem"
                v-b-tooltip.hover
                :title="item.erroMensagem"
                class="text-danger"
                style="cursor: pointer;"
              >
                <font-awesome-icon icon="fa-solid fa-circle-exclamation" />
              </span>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import api from '../services/api'

export default {
  name: 'HistoricoEnvioAutomatico',
  props: {
    tipoRotina: {
      type: Number,
      required: true,
    },
    tituloRotina: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      logs: [],
      historicosEnvio: [],
      carregandoAlteracoes: false,
      carregandoEnvios: false,
      camposAlteracao: [
        { key: 'data', label: 'Data/Hora', thStyle: { width: '180px' } },
        { key: 'usuario', label: 'Usuário' },
        { key: 'tipoAcao', label: 'Ação', thStyle: { width: '160px' } },
        { key: 'de', label: 'De' },
        { key: 'para', label: 'Para' },
      ],
      camposEnvio: [
        { key: 'data', label: 'Data/Hora', thStyle: { width: '180px' } },
        { key: 'empresaCadastroFederal', label: 'CNPJ/CPF', thStyle: { width: '160px' } },
        { key: 'empresaRazaoSocial', label: 'Empresa', thStyle: { width: '160px' } },
        { key: 'status', label: 'Status', thStyle: { width: '120px' } },
        { key: 'destinatario', label: 'Destinatário' },
        { key: 'erroMensagem', label: '', thStyle: { width: '40px' } },
      ],
    }
  },
  methods: {
    show() {
      this.$refs.modalHistorico.show()
      this.carregarAlteracoes()
      this.carregarEnvios()
    },
    carregarAlteracoes() {
      this.carregandoAlteracoes = true
      api.getLogs(this.tipoRotina)
        .then(payload => { this.logs = payload.data })
        .catch(() => { this.$erro('Não foi possível carregar o histórico de alterações.') })
        .finally(() => { this.carregandoAlteracoes = false })
    },
    carregarEnvios() {
      this.carregandoEnvios = true
      api.getHistoricoEnvios(this.tipoRotina)
        .then(payload => { this.historicosEnvio = payload.data })
        .catch(() => { this.$erro('Não foi possível carregar o histórico de envios.') })
        .finally(() => { this.carregandoEnvios = false })
    },
    formatarData(data) {
      if (!data) return ''
      return new Date(data).toLocaleString('pt-BR')
    },
    labelAcao(tipoAcao) {
      const labels = { 0: 'Config. alterada', 1: 'Empresa adicionada', 2: 'Empresa removida' }
      return labels[tipoAcao] ?? tipoAcao
    },
    variantAcao(tipoAcao) {
      const variants = { 0: 'light-primary', 1: 'light-success', 2: 'light-danger' }
      return variants[tipoAcao] ?? 'light-secondary'
    },
    labelStatus(status) {
      const labels = { 0: 'Pendente', 1: 'Enviado', 2: 'Erro' }
      return labels[status] ?? status
    },
    variantStatus(status) {
      const variants = { 0: 'light-warning', 1: 'light-success', 2: 'light-danger' }
      return variants[status] ?? 'light-secondary'
    },
  },
}
</script>

<style>
.modal-historico-envio {
  max-width: 960px;
  margin: auto;
}
</style>
